import { createFileRoute } from "@tanstack/react-router";

import { auditBookingYear } from "@/core/lib/access";
import { guardAgbwTabAccess } from "@/features/audit/lib/agbw-output-acknowledgement";
import { requireAuditDossier } from "@/features/project/components/pages/project-page-context-hooks";

export const Route = createFileRoute(
  "/_protected/auditor/clients/$id/agbw-results/miscellaneous",
)({
  beforeLoad: async ({ context: { queryClient, active, ...context } }) => {
    const organizationId = context.user.organization?.id;

    if (!organizationId) {
      throw new Error("No organization ID found for the current user.");
    }

    await guardAgbwTabAccess(
      queryClient,
      active.id,
      organizationId,
      auditBookingYear(requireAuditDossier(active)),
    );
  },
});
